// ForgotPasswordForm.tsx
import React, { useCallback } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { useAuthStore } from '../../../stores/auth';

interface ForgotPasswordFormInputs {
    email: string;
}

const forgotPasswordSchema = yup.object().shape({
    email: yup.string().email('Email không hợp lệ').required('Email là bắt buộc'),
});

interface ForgotPasswordFormProps {
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = () => {
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<ForgotPasswordFormInputs>({
        resolver: yupResolver(forgotPasswordSchema),
    });

    const { forgotPassword } = useAuthStore();

    const onSubmit: SubmitHandler<ForgotPasswordFormInputs> = useCallback(async (data) => {
        await forgotPassword(data.email);
    }, [forgotPassword]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 w-full h-full flex flex-col justify-center items-center">
            <div className="w-full h-full">
                <label htmlFor="forgot-email" className="block text-sm font-medium text-gray-700">
                    Email
                </label>
                <Input
                    id="forgot-email"
                    type="email"
                    placeholder="you@example.com"
                    {...register('email')}
                    className="mt-1 w-full"
                />
                {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
            </div>
            <Button type="submit" disabled={isSubmitting} className="w-full">
                {isSubmitting ? 'Đang xử lý...' : 'Gửi OTP'}
            </Button>
        </form>
    );
};

export default React.memo(ForgotPasswordForm);